import {valueAsBool} from 'services/utils/valueAsBool';
import type {BooleanCondition} from '../types';
import type {EvaluationArgs} from './types';
import {evaluateValWithDefault} from './evaluateValWithDefault';

export const evaluateBooleanCondition = (
  condition: BooleanCondition,
  args: EvaluationArgs,
): boolean => {
  const arg = evaluateValWithDefault(condition.arg, args, args.value);

  return valueAsBool(arg);
};
